<template>
  <div style="background-color: #F4F7FE; min-height: 100vh;" class="pa-6">
    <v-row class="mb-6 px-4" align="center">
      <v-col cols="12" md="6">
        <h2 class="text-h4 font-weight-black" style="color: #1B2559;">Ajustes del Sistema</h2>
        <div class="d-flex align-center mt-1">
          <v-icon small color="#4318FF" class="mr-2">mdi-cog-outline</v-icon>
          <span class="text-subtitle-2 font-weight-bold" style="color: #A3AED0;">
            Personalice la identidad y datos generales de LIVE FIT
          </span>
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" lg="10">
        <v-card class="rounded-xl elevation-1 border-0 pa-8">
          <form-configuracion 
            :ajustes="datosAjustes" 
            @registrar="onRegistrar" 
            v-if="datosAjustes"
          />
        </v-card>
      </v-col>
    </v-row>

    <v-overlay :value="cargando" color="#1B2559" opacity="0.8">
      <div class="text-center">
        <v-progress-circular 
          indeterminate 
          size="64" 
          color="#4318FF" 
          width="6"
        ></v-progress-circular>
        <div class="mt-4 white--text font-weight-bold text-uppercase">
          Guardando cambios...
        </div>
      </div>
    </v-overlay>

    <v-snackbar 
      v-model="mostrarMensaje" 
      :timeout="3000" 
      :color="mensaje.color" 
      top 
      rounded="pill"
    >
      <v-icon left color="white">mdi-check-circle-outline</v-icon>
      {{ mensaje.texto }}
    </v-snackbar>
  </div>
</template>

<script>
import FormConfiguracion from './FormConfiguracion.vue'
import HttpService from '../../Servicios/HttpService'

export default {
    name: "ConfiguracionPremium",
    components: { FormConfiguracion },

    data:()=>({
        datosAjustes: null,
        cargando: false,
        mostrarMensaje: false, 
        mensaje: {
            texto: "",
            color: ""
        }
    }),

    mounted(){
        this.obtenerAjustes()
    },

    methods: {
        onRegistrar(ajustes){
            this.cargando = true
        
            const imagenCambia = ajustes.logo.includes('data:image')
            if(!imagenCambia){
                ajustes.logo = ajustes.logo.split('api/')[1]
            }
            ajustes.logoCambia = imagenCambia
            
            HttpService.registrar({
                metodo: 'registrar',
                ajustes: ajustes
            }, 'ajustes.php')
            .then(resultado =>{
                if(resultado){
                    this.mostrarMensaje = true
                    this.mensaje = {
                        texto: "Información de la empresa actualizada con éxito",
                        color: "success"
                    }
                    this.cargando = false
                    this.obtenerAjustes()
                }
            }).catch(() => {
                this.cargando = false;
            })
        },

        obtenerAjustes(){
            this.cargando = true
            HttpService.obtenerConDatos(
                { metodo: 'obtener'},
                'ajustes.php'
            )
            .then(resultado => {
                this.datosAjustes = resultado
                this.cargando = false
            })
        }
    }
}
</script>

<style scoped>

.v-card {
  transition: box-shadow 0.3s ease-in-out;
}
.v-card:hover {
  box-shadow: 0 10px 30px rgba(0,0,0,0.08) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Configuracion/ConfiguracionComponent.vue